<template>
  <div class="license-exceeded-state">
    <div class="empty">
      <div class="empty-icon">
        <fa-icon :icon="['fal', 'exclamation-triangle']" size="3x"></fa-icon>
      </div>
      <p class="empty-title h5">Limite de licenças atingido</p>
      <p class="empty-subtitle">
        O número máximo de licenças do plano contratado já foi utilizado.
        <br>
        <span class="text-info">
          Para obter mais informações, entre em contato com o administrador.
        </span>
      </p>
      <div class="empty-action">
        <slot>
          <router-link
            v-if="canManageAccount"
            class="btn btn-primary mr-1 ml-1"
            to="/customer/licenses"
          >Clique aqui para gerenciar sua conta</router-link>

          <router-link class="btn btn-gray-outline btn-icon btn-icon-left" to="/logout">
            <fa-icon :icon="['fal', 'sign-out-alt']"/>Sair
          </router-link>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { MANAGE_CUSTOMER_ACCOUNT } from '@/data/actions/modules/general';

export default {
  name: 'LicenseExceededState',
  computed: {
    canManageAccount() {
      return this.$can(MANAGE_CUSTOMER_ACCOUNT);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.license-exceeded-state {
  margin: 0 auto;
  max-width: $control-width-lg;
  .empty {
    background-color: $light-color;
    border: $border-width solid $border-color;
  }
  .empty-icon {
    svg {
      color: $warning-color;
    }
  }
}
</style>
